import axios from '@/utils/http.js'

const isObject = value => value !== null
  && typeof value === 'object'
  && !Array.isArray(value)

const normalizeUserInfo = payload => {
  if (!isObject(payload)) return null

  const status = Number(payload.status ?? payload.code)

  if (payload.success === false || status === 401 || status === 403) {
    return null
  }

  const candidates = [
    payload.data?.user_info,
    payload.data?.userinfo,
    payload.data?.user,
    payload.data?.account,
    payload.user_info,
    payload.userinfo,
    payload.user,
    payload.account,
    payload.data,
    payload,
  ]

  const user = candidates.find(candidate => {
    if (!isObject(candidate)) return false

    return Boolean(
      candidate.username
      || candidate.user_name
      || candidate.nickname
      || candidate.name
    )
  })

  if (!user) return null

  return {
    ...user,
    username: String(
      user.username
      || user.user_name
      || user.nickname
      || user.name
    ),
  }
}

export const fetchCurrentUserInfo = async () => {
  try {
    // Cookie is browser-managed; in development the axios base URL points to the API domain.
    const response = await axios.get('/user_info', {
      timeout: 10000,
      withCredentials: true,
    })

    return normalizeUserInfo(response?.data)
  } catch (error) {
    console.error('用户信息请求失败:', error)
    return null
  }
}
